<template>
  <div id="keyConfigParamYh" class="key-config-container">
    <!-- 页面标题 + 读取按钮 -->
    <div class="page-title">
      按键配置信息
    </div>

    <!-- 按键标签切换栏 -->
    <div class="key-tabs">
      <div
        v-for="sort in 6"
        :key="sort"
        class="key-tab"
        :class="{ active: activeSort === sort }"
        @click="switchKey(sort)"
        :disabled="!keyConfigs.some(item => item.sort === sort)"
      >
        按键{{ sort }}
        <!-- 无配置时显示角标提示 -->
        <sup v-if="!keyConfigs.some(item => item.sort === sort)" class="no-data-badge">无配置</sup>
      </div>
    </div>

    <!-- 无数据提示 -->
    <div v-if="!currentConfig" class="empty-tip">
      <el-empty description="暂无当前按键的配置数据，请先配置基础参数"></el-empty>
    </div>

    <!-- 当前按键的参数展示区域 -->
    <div v-else class="param-content">

      <!-- 参数列表 -->
      <div class="param-list-container">
        <div class="param-list-header">
          <span>参数名称</span>
          <span>参数值</span>
        </div>
        <div v-if="currentConfig.cupTypeParameters && currentConfig.cupTypeParameters.length" class="param-list">
          <div
            v-for="param in currentConfig.cupTypeParameters"
            :key="param.id"
            class="param-item"
            :title="`${param.name}: ${param.value}`"
          >
            <span class="param-name">{{ param.name }}</span>
            <span class="param-value">{{ param.value }}</span>
          </div>
        </div>
        <div v-else class="param-empty-tip">暂无参数数据</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KeyConfigParamYh",
  props:{
    initValue:null
  },
  data() {
    return {
      keyConfigs: [], // 所有按键配置
      activeSort: 1, // 当前选中按键
      currentConfig: null, // 当前按键配置
      currentKey: {
        id:0,
        currentCupQuantity: 0, // 已出杯数
        setCupQuantity: 0 // 设定管控杯数
      },
      isSaving: false, // 保存加载状态
      rawMaintain: [], // 读取到的管控值数组
      isLoadingMaintain: false, // 读取加载状态
      hasReadMaintain: false // 是否已完成读取（控制保存按钮显示）
    };
  },
  mounted() {
      console.log("当前设备id",this.initValue)
    this.loadKeyConfigs(); // 加载基础按键配置
  },
  watch: {
    // 切换按键时重置输入框
    activeSort: function(newVal) {
      this.resetCurrentKey();
      // 切换按键时重新匹配已出杯数
      this.matchCurrentCupQuantity(newVal);
    }
  },
  methods: {
    /**
     * 读取设备管控值（核心：标记已读取 + 匹配当前按键杯数）
     */
    loadMaintain() {
      // 防止重复读取
      if (this.isLoadingMaintain) return;

      this.isLoadingMaintain = true;
      this.$httpservice.get("api/external/yh/raw/maintain?dtuNo=" + this.initValue.dtuNumber)
        .then(res => {
          if (res.body.code === 200) {
            this.rawMaintain = res.body.data || [];
            this.hasReadMaintain = true; // 标记已读取，显示保存按钮
            this.$message.success("读取管控值成功");
            // 读取后自动匹配当前选中按键的已出杯数
            this.matchCurrentCupQuantity(this.activeSort);
          } else {
            this.$message.error("读取管控值失败：" + (res.body.msg || "接口返回异常"));
          }
        })
        .catch(err => {
          console.error("读取管控值失败：", err);
          this.$message.error("读取管控值失败，请稍后重试");
        })
        .finally(() => {
          this.isLoadingMaintain = false;
        });
    },

    /**
     * 匹配当前按键的已出杯数（核心逻辑）
     * @param {number} sort 按键序号
     */
    matchCurrentCupQuantity(sort) {
      console.log("触发",sort)
      // 从rawMaintain中找sort匹配的对象，找不到则设为0
      const matchItem = this.rawMaintain.find(item => item.sort === sort);
      this.currentKey.id = matchItem?(matchItem.id || 0) : 0;
      this.currentKey.setCupQuantity = matchItem?(matchItem.setCupQuantity || 0):0
      this.currentKey.currentCupQuantity = matchItem ? (matchItem.currentCupQuantity || 0) : 0;
    },

    /**
     * 保存配置
     */
    saveRawMaintain() {
      // 1. 输入校验
      if (this.currentKey.setCupQuantity < 0) {
        this.$message.warning("设定杯量管控数不能为负数");
        return;
      }

      // 2. 防止重复提交
      if (this.isSaving) return;

      this.isSaving = true;
      const submitData = {
        id:this.currentKey.id,
        setCupQuantity: this.currentKey.setCupQuantity,
      };
      console.log(this.currentKey)
      return false;
      this.$httpservice.put("api/external/yh/raw/maintain/update", submitData)
        .then(res => {
          if (res.body && res.body.code === 200) {
            this.$message.success("配置保存成功");
          } else {
            this.$message.error("配置保存失败：" + (res.body.msg || "接口返回异常"));
          }
        })
        .catch(err => {
          console.error("保存杯量配置失败：", err);
          this.$message.error("配置保存失败，请稍后重试");
        })
        .finally(() => {
          this.isSaving = false;
        });
    },

    /**
     * 加载基础按键配置
     */
    loadKeyConfigs() {
      this.$httpservice.get("api/external/yh/general/load/1?equipmentId="+this.initValue.id)
        .then(res => {
          if (res.body && res.body.code === 200) {
            this.keyConfigs = res.body.data || [];
            this.switchKey(this.activeSort);
          } else {
            this.$message.warning("加载配置数据失败：" + (res.body.msg || "接口返回异常"));
          }
        })
        .catch(err => {
          console.error("加载按键配置失败：", err);
          this.$message.error("加载配置数据失败，请刷新页面重试");
        });
    },

    /**
     * 切换按键
     * @param {number} sort 按键序号
     */
    switchKey(sort) {
      const targetSort = Number(sort);
      const hasConfig = this.keyConfigs.some(item => item.sort === targetSort);

      if (!hasConfig) {
        this.$message.info("该按键暂无配置数据");
      }

      this.activeSort = targetSort;
      this.currentConfig = this.keyConfigs.find(item => item.sort === targetSort) || null;
      if (this.currentConfig && this.currentConfig.cupTypeParameters) {
        let params = this.currentConfig.cupTypeParameters;

        // 按 sort 升序排序，无 sort 则按名称
        params = params.sort((a, b) => {
          if (a.sort !== undefined && b.sort !== undefined) {
            return a.sort - b.sort;
          }
          return (a.name || "").localeCompare(b.name || "");
        });
      }
      // 切换按键时匹配已出杯数（核心）
      if (this.currentConfig) {
        this.matchCurrentCupQuantity(targetSort);
      }
    },

    /**
     * 输入框校验
     * @param {number} val 输入值
     */
    handleCupQuantityInput(val) {
      if (val === "" || val === null || val < 0) {
        this.currentKey.setCupQuantity = 0;
      }
      if (isNaN(val)) {
        this.currentKey.setCupQuantity = 0;
        this.$message.warning("请输入有效的数字");
      }
    },

    /**
     * 重置输入框
     */
    resetCurrentKey() {
      this.currentKey.setCupQuantity = 0;
    }
  }
};
</script>

<style scoped lang="less">
.key-config-container {
  width: 100%;
  max-width: 900px;
  margin: 20px auto;
  padding: 24px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  // 页面标题
  .page-title {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .read-btn {
      padding: 6px 12px;
    }
  }

  // 按键标签栏
  .key-tabs {
    display: flex;
    gap: 12px;
    margin-bottom: 24px;
    flex-wrap: wrap;

    .key-tab {
      padding: 10px 20px;
      background: #f9fafb;
      border: 1px solid #e5e7eb;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.2s ease;
      position: relative;
      font-size: 14px;
      color: #4b5563;

      &:hover:not(.active):not([disabled]) {
        background: #f3f4f6;
        border-color: #d1d5db;
      }

      &.active {
        background: #2563eb;
        color: #fff;
        border-color: #2563eb;
        box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);
      }

      &[disabled] {
        cursor: not-allowed;
        opacity: 0.6;
      }

      .no-data-badge {
        position: absolute;
        top: -4px;
        right: -4px;
        font-size: 10px;
        color: #ef4444;
        background: #fee2e2;
        padding: 1px 4px;
        border-radius: 4px;
        font-weight: 600;
      }
    }
  }

  // 空数据提示
  .empty-tip {
    padding: 60px 20px;
    text-align: center;

    /deep/ .el-empty {
      --el-empty-padding: 0;
      --el-empty-description-color: #6b7280;
    }
  }

  // 参数内容区域
  .param-content {
    .cup-info {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
      margin-bottom: 24px;
      padding: 16px;
      background: #f9fafb;
      border-radius: 8px;

      .info-item {
        display: flex;
        align-items: center;
        font-size: 14px;

        .label {
          font-weight: 500;
          color: #374151;
          margin-right: 8px;
        }

        .value {
          color: #1f2937;
        }
      }

      .input-item {
        align-items: center;
      }

      .cup-quantity-input {
        width: 120px;
      }

      .save-btn {
        margin-left: auto;
        white-space: nowrap;
        padding: 8px 16px;
      }
    }

    .param-list-container {
      background: #f9fafb;
      border-radius: 8px;
      overflow: hidden;

      .param-list-header {
        display: grid;
        grid-template-columns: 1fr 1fr;
        padding: 12px 16px;
        background: #f3f4f6;
        border-bottom: 1px solid #e5e7eb;
        font-weight: 600;
        color: #374151;
        font-size: 14px;
      }

      .param-list {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1px;
        background: #e5e7eb;

        .param-item {
          padding: 12px 16px;
          background: #fff;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;
          transition: background 0.2s;

          &:hover {
            background: #f9fafb;
          }

          .param-name {
            color: #4b5563;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .param-value {
            color: #2563eb;
            font-weight: 500;
          }
        }
      }

      .param-empty-tip {
        padding: 40px 20px;
        text-align: center;
        color: #6b7280;
        font-size: 14px;
      }
    }
  }
}

// 响应式适配
@media (max-width: 768px) {
  .key-config-container {
    padding: 16px;
    margin: 10px;

    .cup-info {
      flex-direction: column;
      align-items: flex-start;

      .save-btn {
        margin-left: 0;
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/equipmentmanagement/KeyConfigParamYh.vue